import { createComparator } from '@tmapy/utils';
const excludeSelf = (array, self) => {
    const result = [...array];
    const index = array.indexOf(self);
    result.splice(index, 1);
    return result;
};
export const buildMapSwitcherConfig = (tinkerConfig, nonTranslatableResourceStrings) => {
    const mapSwitcherLayers = tinkerConfig.mapLayers.edges
        .map((mapLayer) => mapLayer.node)
        .filter((mapLayer) => mapLayer.isInMapSwitcher)
        .sort(createComparator((asc) => asc.order, (asc) => asc.id));
    const mapSwitcherExclusiveLayerIds = mapSwitcherLayers
        .filter((mapLayer) => !mapLayer.isInLayerSwitcher)
        .map((mapLayer) => mapLayer.nameId);
    return mapSwitcherLayers.map((mapLayer) => {
        nonTranslatableResourceStrings[`layer.${mapLayer.nameId}`] = mapLayer.title;
        return {
            layerId: mapLayer.nameId,
            image: mapLayer.mapService.thumbnail,
            exclusiveLayerIds: mapLayer.isInLayerSwitcher
                ? []
                : excludeSelf(mapSwitcherExclusiveLayerIds, mapLayer.nameId),
            isOpacitySliderVisible: mapLayer.isOpacitySliderVisible,
        };
    });
};
//# sourceMappingURL=buildMapSwitcherConfig.js.map